<template>
  <div class="flex justify-around my-4 pr-16">
    <div class="space-x-4 items-center">
      <div>
        <h3 class="text-sm font-medium uppercase leading-4">Total (USD)</h3>
        <p class="font-bold text-2xl inline-flex items-center space-x-2">
          $ {{ numberWithPrecision(total_amount) }}
        </p>
      </div>
    </div>
    <!-- <div class="space-x-4 items-center"> -->
    <!--   <div> -->
    <!--     <h3>Cajas</h3> -->
    <!--     <p class="font-bold text-2xl inline-flex items-center space-x-2"> -->
    <!--       {{ numberWithPrecision(total_boxes) }} -->
    <!--     </p> -->
    <!--   </div> -->
    <!-- </div> -->
  </div>
  <!-- <div id="chart4"> -->
  <!--   <apexchart -->
  <!--     type="line" -->
  <!--     height="350" -->
  <!--     width="100%" -->
  <!--     :options="options" -->
  <!--     :series="series" -->
  <!--   ></apexchart> -->
  <!-- </div> -->
</template>

<script>
// import VueApexCharts from "vue3-apexcharts";

export default {
  name: "PRODReportingProcessShowReportsGraphicsHarvestMonthly",
  components: {
    // apexchart: VueApexCharts
  },
  props: { data: { required: true } },
  data() {
    return {
      options: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false
          }
        },
        stroke: {
          curve: "straight"
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5
          }
        },
        xaxis: {
          categories: this.data.months
        },
        yaxis: {
          title: {
            text: "USD"
          },
          labels: {
            formatter: function (val) {
              return `$ ${this.numberWithPrecision(val)}`;
            }.bind(this)
          }
        },
        colors: ["#65A30D", "#3b82f6"],
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: false,
          offsetY: -25,
          offsetX: -5
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return this.numberWithPrecision(val);
            }.bind(this)
          }
        }
      }
    };
  },
  computed: {
    series() {
      return this.data.data.map(item => {
        return {
          name: item.name,
          data: item.values
        };
      });
    },
    total_amount() {
      let data = this.data.data[0].values
      if (data) return data.reduce((sum, v) => sum + v, 0);
      return 0;
    },
    total_boxes() {
      return this.data.data[1].values
        .reduce((sum, v) => sum + v, 0);
    }
  },
  methods: {
    harvestedByCropField(item) {
      return item.values.reduce((sum, v) => sum + Number(v), 0);
    }
  }
};
</script>
